import { render, staticRenderFns } from "./BCanvasCursor.vue?vue&type=template&id=21543702&scoped=true&"
import script from "./BCanvasCursor.vue?vue&type=script&lang=ts&"
export * from "./BCanvasCursor.vue?vue&type=script&lang=ts&"
function injectStyles (context) {
  
  var style0 = require("./BCanvasCursor.vue?vue&type=style&index=0&id=21543702&scoped=true&lang=scss&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "21543702",
  null
  ,true
)

export default component.exports